import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AuthContext from "../context/auth/AuthContext";
import PlatoContext from "../context/platos/PlatoContext";
import MenuContext from "../context/menus/MenuContext";
import {
  Form,
  Group,
  Label,
  Input,
  Select,
  Button,
} from "../styles/form.elements";

function FormularioMenu({ platos, toggler }) {
  const fechaActual = new Date().toISOString().slice(0, 10);
  const navigate = useNavigate();
  const { usuario } = useContext(AuthContext);
  const { plato, seleccionarPlato, deseleccionarPlato } =
    useContext(PlatoContext);
  const { creando, crearMenu, prepararNuevoMenu } = useContext(MenuContext);
  const [platoSel, setPlatoSel] = useState("");
  const [fecha, setFecha] = useState("");

  useEffect(() => {
    if (!usuario.administrador) {
      navigate("/");
    }
    // eslint-disable-next-line
  }, [usuario]);

  useEffect(() => {
    if (platoSel !== "") {
      seleccionarPlato(platoSel);
    }
    // eslint-disable-next-line
  }, [platoSel]);

  useEffect(() => {
    if (creando) {
      deseleccionarPlato();
      prepararNuevoMenu();
      return () => {
        setFecha("");
        toggler();
      };
    }
    // eslint-disable-next-line
  }, [creando]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (fecha === "") {
      toast.error("Por favor seleccione una fecha");
      return;
    }

    const data = {
      fecha,
      plato,
      usuario,
    };

    crearMenu(data);
  };

  return (
    <Form onSubmit={onSubmit}>
      <Group>
        <Label htmlFor="desde">Desde</Label>
        <Input
          type="date"
          min={fechaActual}
          id="desde"
          name="desde"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
        />
      </Group>
      <Group>
        <Label htmlFor="plato">Plato</Label>
        <Select
          name="plato"
          id="plato"
          value={platoSel}
          onChange={(e) => setPlatoSel(e.target.value)}
        >
          <option value="">-- seleccione plato --</option>
          {platos.map((platoDisp) => (
            <option key={platoDisp.id} value={platoDisp.id}>
              {platoDisp.nombre}
            </option>
          ))}
        </Select>
      </Group>
      <Group>
        <Button type="submit">Crear</Button>
      </Group>
    </Form>
  );
}
export default FormularioMenu;
